import { ProductFruits } from 'react-product-fruits';
import Config from 'src/common/Config';
import { User } from 'src/admin/users/types';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { useUserStore } from 'src/auth/useUserStore';

const workspaceCode = import.meta.env.VITE_PRODUCT_FRUITS_WORKSPACE_CODE;

type Props = {
  currentUser: User;
};

export function ProductFruitsLoader({ currentUser }: Props) {
  const { flagEnabledProductFruits } = useFlags();
  const tenantId = useUserStore(state => state.tenantId);

  if (!flagEnabledProductFruits || !workspaceCode) return null;

  return (
    <ProductFruits
      workspaceCode={workspaceCode}
      language="en"
      user={{
        username: currentUser.id,
        email: currentUser.emailAddress,
        firstname: currentUser.firstName,
        lastname: currentUser.lastName,
        signUpAt: currentUser.createdAt,
        role: currentUser.userRole,
        props: { environment: Config.getObservabilityEnvironment() },
        ...(tenantId && { group: { groupId: tenantId } }),
      }}
    />
  );
}
